import { render, staticRenderFns } from "./exam-schedule.vue?vue&type=template&id=5b55c506&scoped=true&"
import script from "./exam-schedule.vue?vue&type=script&lang=js&"
export * from "./exam-schedule.vue?vue&type=script&lang=js&"
import style0 from "./exam-schedule.vue?vue&type=style&index=0&id=5b55c506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b55c506",
  null
  
)

export default component.exports